import Swup from "swup";
import SwupScriptsPlugin from "@swup/scripts-plugin";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupProgressPlugin from "@swup/progress-plugin";
import SwupHtmlLangPlugin from "@mashvp/swup-html-lang-plugin";
import SwupMetaTagsPlugin from "swup-meta-tags-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";

// change SwupScrollPlugin behavior for cases where there is an anchor in the url but not matching element is found
const SwupScrollPluginInstance = new SwupScrollPlugin();

SwupScrollPluginInstance.doScrollingOriginal = SwupScrollPluginInstance.doScrolling;
SwupScrollPluginInstance.doScrolling = function (popstate) {
  const swup = this.swup;
  if (
    (!popstate || swup.options.animateHistoryBrowsing) &&
    swup.scrollToElement != null
  ) {
    const element = document.querySelector(swup.scrollToElement);
    if (element === null) {
      swup.scrollTo(0);
      return;
    }
  }

  this.doScrollingOriginal(popstate);
};

const swup = new Swup({
  containers: [".header", ".meta-nav", ".swup-replace-content"],
  animationSelector: '[class*="swup-transition-"]',
  plugins: [
    new SwupPreloadPlugin(),
    new SwupScriptsPlugin({ body: true }),
    new SwupProgressPlugin({ delay: 500 }),
    new SwupMetaTagsPlugin(),
    new SwupHtmlLangPlugin(),
    SwupScrollPluginInstance,
    // new SwupScrollPlugin(),
  ],
});

swup.cache.remove(window.location.pathname + window.location.search);

const closeEvent = new CustomEvent("mobile-menu-close");

swup.on("pageView", () => {
  document.body.classList.remove("overflow-hidden");
  if (window.disclaimer) {
    // window.disclaimer.checkDisclaimer();
  }
  if (window.cookieBox) {
    window.cookieBox.checkCookieBox();
  }

  window.dispatchEvent(new CustomEvent("initSliders"));
});

swup.on("clickLink", function () {
  window.dispatchEvent(closeEvent);
});

// Create an event listener for tracking the Jentis page view
swup.on("contentReplaced", () => {
  window._jts = window._jts || [];
  window._jts.push({ track: "pageview" });
  window._jts.push({ track: "submit" });
});
